import { withCompInfo } from '@wix/editor-elements-integrations'

export const props = withCompInfo<any, any>()(['compData'], ({ compData }) => {
	const { link = {} } = compData
	return { link }
})
